<template>
  <button @click="exportTransaction" class="btn btn-info is-border-1 mr-1 mb-2">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop
             no-enforce-focus>
      <b-progress :max="totalCount">
        <b-progress-bar :value="downloadedCount"
                        :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
      </b-progress>
    </b-modal>
  </button>
</template>


<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';
import moment from 'moment';

export default {
  name: "CallHistoryExport",
  props: ['filter', 'totalCount'],
  data() {
    return {
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0
    }
  },
  methods: {
    exportTransaction: async function () {
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      this.setupSheet(sheet);

      let response = null;
      let params = Object.assign({}, this.filter);
      params.page = 1;
      params.pageSize = 500;
      do {
        if (this.cancelRequest) {
          break;
        }
        let result = await this.$service.get('/zns', {
          params: params
        });
        params.page += 1;
        response = result.data;
        response.docs.forEach(item => {
          let row = {
            client: item.client.domain,
            oa: item.oa && item.oa.name ? item.oa.name : '',
            template: item.template && item.template.name ? item.template.name : '',
            user: item.user ? `${item.user.name} (${item.user.ext})`: '',
            phone: item.phone,
            createTime: moment(item.createTime).format('DD/MM/YYYY HH:mm:ss'),
            sendTime: moment(item.sendTime).format('DD/MM/YYYY HH:mm:ss'),
            chargeTime: moment(item.chargeTime).format('DD/MM/YYYY HH:mm:ss'),
            chargedFee: item.chargedFee,
            type: this.$t(item.type),
            sendErrorMsg: item.sendErrorMsg,
            developmentMode: item.developmentMode ? "Development mode" : '',
          }
          row.status = '';
          if(!item.sendTime) {
            row.status = this.$t('notYetSent');
          }
          if(item.sendTime && !item.sendError) {
            row.status = this.$t('success');
          }
          if(item.sendTime && item.sendError) {
            row.status = this.$t('error');
          }

          sheet.addRow(row);
          this.downloadedCount += 1;
        });
      } while (response && response.hasNextPage);

      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        this.exporting = false;
        saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            'zns-history.xlsx');
      }).finally(() => {
        this.cancelRequest = false;
        this.downloadedCount = 0;
      });
    },
    setupSheet: function (sheet) {
      sheet.columns = [
        {header: this.$t('client'), key: 'client', width: 15},
        {header: this.$t('user'), key: 'user', width: 15},
        {header: this.$t('oa'), key: 'oa', width: 15},
        {header: this.$t('template'), key: 'template', width: 15},
        {header: this.$t('type'), key: 'type', width: 15},
        {header: this.$t('phone'), key: 'phone', width: 15},
        {header: this.$t('createTime'), key: 'createTime', width: 15},
        {header: this.$t('sendTime'), key: 'sendTime', width: 15},
        {header: this.$t('chargeTime'), key: 'chargeTime', width: 15},
        {header: this.$t('chargedFee'), key: 'chargedFee', width: 50},
        {header: this.$t('status'), key: 'status', width: 15},
        {header: this.$t('sendErrorMsg'), key: 'sendErrorMsg', width: 15},
      ];
    },
    close() {
      this.cancelRequest = true;
    }
  },

}
</script>